import './ccf-mail-outline-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfMailOutlineIconProps extends SvgIconProps {}

/**
 * CcfMailOutlineIcon used to disply meesage outline icon in the contact card panel
 * @param props - CcfMailOutlineIconProps
 * @example -- <CcfMailOutlineIcon />
 */
export function CcfMailOutlineIcon(props: CcfMailOutlineIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_mail_outline" clipPath="url(#clip-ic_mail_outline)">
        <path id="Email-Message" d="M16.2,4.8H1.8C0,4.8,0,5.7,0,6.6v9.9c0,.63,0,1.8,1.8,1.8H16.2c1.8,0,1.8-1.17,1.8-1.8V6.6C18,5.7,18,4.8,16.2,4.8Zm0,11.7H1.8V6.6H16.2v9.9ZM2.7,13.71a.822.822,0,0,0,0,1.08.944.944,0,0,0,1.17,0l2.34-2.25c.09-.09.09-.18.18-.27l1.98,1.89a.557.557,0,0,0,.63.18,1.669,1.669,0,0,0,.63-.18l1.89-1.8a.314.314,0,0,0,.09.18l2.34,2.25a.944.944,0,0,0,1.17,0,.821.821,0,0,0,0-1.08l-2.34-2.25c-.09-.09-.09-.09-.18-.09l2.43-2.34a.821.821,0,0,0,0-1.08.944.944,0,0,0-1.17,0L9,12.54,4.049,7.86a.944.944,0,0,0-1.17,0,.821.821,0,0,0,0,1.08l2.43,2.34c-.09,0-.18.09-.27.18L2.7,13.71Z" transform="translate(3 0.45)" fill="#526b7a"/>
      </g>
    </SvgIcon>
  );
}

export default CcfMailOutlineIcon;
